export default __webpack_public_path__ + "static/media/criticalcare.023e81e3.png";